const appInfo = {
    title: 'AnaLIS-WEB'
};
export default appInfo;

